<template>
    <div class="map-wrapper">
        <div class="loader-wrapper" v-if="loading">
            <Loader />
        </div>
        <section class="media-map__hero" v-show="!loading">
            <div class="hero__main">
                <div class="hero__container site__container">
                    <div class="row">
                        <div class="col-lg-12">
                            <h2 class="hero-title">Mapa nośników</h2>

                            <div class="map__controls">
                                <div class="map__selects">
                                    <div
                                        class="map__select map__select--address"
                                    >
                                        <svg
                                            class="map__hamburger"
                                            width="18px"
                                            height="12px"
                                            viewBox="0 0 18 12"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                        >
                                            <g
                                                id="Page-1"
                                                stroke="none"
                                                stroke-width="1"
                                                fill="none"
                                                fill-rule="evenodd"
                                            >
                                                <g
                                                    id="design_Mapa_nośników"
                                                    transform="translate(-329.000000, -311.000000)"
                                                    fill="#616161"
                                                >
                                                    <g
                                                        id="google_maps_search"
                                                        transform="translate(310.000000, 293.000000)"
                                                    >
                                                        <g
                                                            id="ic_more"
                                                            transform="translate(19.000000, 18.000000)"
                                                        >
                                                            <rect
                                                                id="Rectangle-2"
                                                                x="0"
                                                                y="0"
                                                                width="18"
                                                                height="2"
                                                            ></rect>
                                                            <rect
                                                                id="Rectangle-2-Copy"
                                                                x="0"
                                                                y="5"
                                                                width="18"
                                                                height="2"
                                                            ></rect>
                                                            <rect
                                                                id="Rectangle-2-Copy-2"
                                                                x="0"
                                                                y="10"
                                                                width="18"
                                                                height="2"
                                                            ></rect>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>

                                        <input
                                            type="text"
                                            class="input--address"
                                            ref="autocomplete"
                                        />

                                        <div class="map__directions-icon">
                                            <svg
                                                width="21px"
                                                height="20px"
                                                viewBox="0 0 21 20"
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                            >
                                                <g
                                                    id="Page-1"
                                                    stroke="none"
                                                    stroke-width="1"
                                                    fill="none"
                                                    fill-rule="evenodd"
                                                >
                                                    <g
                                                        id="design_Mapa_nośników"
                                                        transform="translate(-604.000000, -307.000000)"
                                                        fill="#FDB913"
                                                    >
                                                        <g
                                                            id="google_maps_search"
                                                            transform="translate(310.000000, 293.000000)"
                                                        >
                                                            <g
                                                                id="ic_directions_black_24px"
                                                                transform="translate(294.007500, 13.997500)"
                                                            >
                                                                <path
                                                                    d="M19.7025,9.2925 L10.7025,0.2925 C10.3125,-0.0975 9.6825,-0.0975 9.2925,0.2925 L0.2925,9.2925 C-0.0975,9.6825 -0.0975,10.3125 0.2925,10.7025 L9.2925,19.7025 C9.6825,20.0925 10.3125,20.0925 10.7025,19.7025 L19.7025,10.7025 C20.0925,10.3225 20.0925,9.6925 19.7025,9.2925 L19.7025,9.2925 Z M11.9925,12.5025 L11.9925,10.0025 L7.9925,10.0025 L7.9925,13.0025 L5.9925,13.0025 L5.9925,9.0025 C5.9925,8.4525 6.4425,8.0025 6.9925,8.0025 L11.9925,8.0025 L11.9925,5.5025 L15.4925,9.0025 L11.9925,12.5025 L11.9925,12.5025 Z"
                                                                    id="Shape"
                                                                ></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                    <div
                                        class="map__select map__select--distance"
                                    >
                                        <svg
                                            class="map__plus"
                                            width="13px"
                                            height="11px"
                                            viewBox="0 0 13 11"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                        >
                                            <g
                                                id="Page-1"
                                                stroke="none"
                                                stroke-width="1"
                                                fill="none"
                                                fill-rule="evenodd"
                                            >
                                                <g
                                                    id="design_Mapa_nośników"
                                                    transform="translate(-696.000000, -312.000000)"
                                                    fill="#616161"
                                                >
                                                    <g
                                                        id="google_maps_search"
                                                        transform="translate(310.000000, 293.000000)"
                                                    >
                                                        <g
                                                            id="Group-2"
                                                            transform="translate(373.000000, 0.000000)"
                                                        >
                                                            <g
                                                                id="San-Mateo-CA,-United-States-Copy"
                                                                transform="translate(13.500000, 16.000000)"
                                                            >
                                                                <g
                                                                    id="Icons/add_cross_ico"
                                                                    transform="translate(0.000000, 3.000000)"
                                                                >
                                                                    <rect
                                                                        id="Rectangle"
                                                                        x="4.5"
                                                                        y="0"
                                                                        width="2"
                                                                        height="11"
                                                                        rx="1"
                                                                    ></rect>
                                                                    <rect
                                                                        id="Rectangle-Copy"
                                                                        transform="translate(6.000000, 5.500000) rotate(90.000000) translate(-6.000000, -5.500000) "
                                                                        x="5"
                                                                        y="-0.5"
                                                                        width="2"
                                                                        height="12"
                                                                        rx="1"
                                                                    ></rect>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>

                                        <v-select
                                            :searchable="false"
                                            :options="distance.options"
                                            :placeholder="'Odległość'"
                                            v-model="distance.selected"
                                            :reduce="opt => opt.distanceInKm"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="map__filters">
                                    <div
                                        class="map__filter"
                                        v-for="category of categories"
                                        v-on:click="
                                            category.active = !category.active;
                                            clearPopups();
                                            redrawMarkers();
                                        "
                                    >
                                        <div
                                            class="map__filter__dot"
                                            v-bind:class="{
                                                'map__filter__dot--active':
                                                    category.active,
                                                'map__filter__dot--inactive': !category.active
                                            }"
                                        ></div>
                                        {{ category.name }}
                                    </div>

                                    <div
                                        class="map__filter"
                                        v-if="TramDataFeatureArray"
                                        v-on:click="
                                            showPublicTransport = !showPublicTransport;
                                            redrawPublicTransport();
                                        "
                                    >
                                        <div
                                            class="map__filter__dot"
                                            v-bind:class="{
                                                'map__filter__dot--active': showPublicTransport,
                                                'map__filter__dot--inactive': !showPublicTransport
                                            }"
                                        ></div>
                                        {{ translations.public_transport }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div
            class="map"
            ref="map"
            v-bind:style="{ opacity: loading ? 0.5 : 1 }"
        ></div>

        <div
            ref="media-details"
            v-bind:style="{
                display: 'none'
            }"
        >
            <MediaDetails
                v-bind:current="current"
                v-on:close="
                    clearPopups();
                    deactivateMarker();
                "
            />
        </div>
    </div>
</template>

<script type="text/babel">
import {
    ACTIVE_MARKER,
    CATEGORIES,
    DISTANCE_OPTIONS,
    GOOGLE_MAP_STYLES,
    WARSAW
} from "../shared/constants";
import gmapsInit from "../shared/google-maps";
import MediaDetails from "./components/MediaDetails";
import { haversineDistance } from "../shared/geo";
import slugify from "slugify";
import { getMarker } from "../shared/utils";
import Loader from "../shared/components/Loader";
import {
    getLocalizations,
    getPublicTransport
} from "../shared/wp-ajax.service";

export default {
    components: {
        MediaDetails,
        Loader
    },
    data() {
        return {
            center: WARSAW,
            zoom: 13,
            projects: [],
            markers: [],
            styles: GOOGLE_MAP_STYLES,
            map: undefined,
            google: undefined,
            bounds: undefined,
            mapOffset: 0, // INFO: if we have overlay, then "center" should be shifted
            mobile: false,
            markerCluster: undefined,
            isMapDragged: false,
            pristine: true,
            current: {
                img: undefined,
                title: undefined,
                address: undefined,
                lat: undefined,
                lng: undefined,
                countMedia: undefined,
                countReceivers: undefined
            },
            filters: [],
            popups: [],
            distance: {
                selected: null,
                options: DISTANCE_OPTIONS
            },
            categories: [],
            loading: true,
            showPublicTransport: false,
            TramDataFeatureArray: undefined
        };
    },
    created() {
        window.addEventListener("resize", e => {
            this.windowResized(e);
        });
        this.setOffset();
    },
    destroyed() {
        window.removeEventListener("resize", e => {
            this.windowResized(e);
        });
    },
    async mounted() {
        try {
            this.google = await gmapsInit();
            this.map = new this.google.maps.Map(this.$refs.map, {
                center: this.center,
                zoom: this.zoom
            });
            this.map.setOptions({
                styles: this.styles
            });
            this.bounds = new this.google.maps.LatLngBounds();
            getLocalizations()
                .then(result => {
                    this.projects = result.data;
                    this.setupFilters();
                    this.setupCategories();
                    this.redrawMarkers();
                    const [firstMarker] = this.markers;
                    if (firstMarker) {
                        this.moveTo(firstMarker.getPosition());
                        this.adjustZoom();
                        // this.markerCluster = new MarkerClusterer(this.map, this.markers, {
                        //     imagePath: MARKER_CLUSTERER_ICON_PATH,
                        // });
                        this.initMoveEvents();
                        this.initAutocompleteInput();
                        // this.getActiveCategoriesFromUrl();
                        this.actionsFromUrl();
                    }
                    getPublicTransport()
                        .then(result => {
                            this.geojson = result.data;
                            this.showPublicTransport = true;
                            this.redrawPublicTransport();
                        })
                        .catch(error => {
                            this.showPublicTransport = false;
                            console.log(error);
                        });
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        } catch (error) {
            console.error(error);
        }
    },
    methods: {
        markerClicked(data, Marker, projectData) {
            this.deactivateMarker();

            Marker.setIcon(ACTIVE_MARKER);

            this.moveTo(data.position);
            this.pristine = false;
            const countMedia = this.filters
                .filter(_filter => _filter.type === data.title)
                .map(_filter => _filter.count)[0];
            const slug = slugify(data.title, {
                lower: true
            });
            this.current = {
                img: projectData.image_url,
                title: data.title,
                address: data.address,
                lat: data.position.lat,
                lng: data.position.lng,
                countMedia: countMedia,
                countReceivers: 999999, // TODO
                slug: slug,
                url: projectData.url
            };

            /**
             * A customized popup on the map.
             */
            class Popup extends google.maps.OverlayView {
                constructor(position, content) {
                    super();
                    this.position = position;
                    content.style.display = "block";
                    content.classList.add("popup-bubble");

                    // This zero-height div is positioned at the bottom of the bubble.
                    const bubbleAnchor = document.createElement("div");

                    bubbleAnchor.classList.add("popup-bubble-anchor");
                    bubbleAnchor.appendChild(content);
                    // This zero-height div is positioned at the bottom of the tip.
                    this.containerDiv = document.createElement("div");
                    this.containerDiv.classList.add("popup-container");
                    this.containerDiv.appendChild(bubbleAnchor);
                    // Optionally stop clicks, etc., from bubbling up to the map.
                    Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
                }

                /** Called when the popup is added to the map. */
                onAdd() {
                    this.getPanes().floatPane.appendChild(this.containerDiv);
                }

                /** Called when the popup is removed from the map. */
                onRemove() {
                    if (this.containerDiv.parentElement) {
                        this.containerDiv.parentElement.removeChild(
                            this.containerDiv
                        );
                    }
                }

                /** Called each frame when the popup needs to draw itself. */
                draw() {
                    const divPosition = this.getProjection().fromLatLngToDivPixel(
                        this.position
                    );
                    // Hide the popup when it is far out of view.
                    const display =
                        Math.abs(divPosition.x) < 4000 &&
                        Math.abs(divPosition.y) < 4000
                            ? "block"
                            : "none";

                    if (display === "block") {
                        this.containerDiv.style.left = divPosition.x + "px";
                        this.containerDiv.style.top = divPosition.y + "px";
                    }

                    if (this.containerDiv.style.display !== display) {
                        this.containerDiv.style.display = display;
                    }
                }
            }
            const popup = new Popup(
                new google.maps.LatLng(data.position.lat, data.position.lng),
                this.$refs["media-details"]
            );
            this.clearPopups();
            popup.setMap(this.map);
            this.popups.push(popup);
            this.active = {
                data: projectData,
                Marker
            };
        },

        redrawMarkers() {
            this.markers.forEach(marker => marker.setMap(null));
            this.markers = [];

            const activeCategories = this.categories
                .filter(c => c.active)
                .map(c => c.name.toLowerCase());

            // const activeFilters = this.filters.filter(f => f.active).map(f => f.type);
            this.markers = this.projects
                .filter(p => {
                    return (
                        p.lat &&
                        p.lng &&
                        activeCategories.includes(p.category.toLowerCase())
                    );
                })
                .map(p => {
                    p.lat = parseFloat(p.lat);
                    p.lng = parseFloat(p.lng);
                    let marker = this.drawMarker(
                        {
                            position: {
                                lat: p.lat,
                                lng: p.lng
                            },
                            icon: getMarker(p.marker_color),
                            title: p.type,
                            address: p.name
                        },
                        p
                    );
                    if (this.searchLatLng && this.distance.selected) {
                        const distance = haversineDistance(
                            {
                                lat: this.searchLatLng.lat(),
                                lng: this.searchLatLng.lng()
                            },
                            p
                        );
                        if (distance > this.distance.selected) {
                            marker.setMap(null);
                        }
                    }

                    return marker;
                });
            this.adjustZoom();
        },

        changeIcon(marker, data) {
            this.markers.map(m => {
                if (
                    m.getPosition().lat() === marker.position.lat &&
                    m.getPosition().lng() === marker.position.lng
                ) {
                    m.setIcon(ACTIVE_MARKER);
                } else {
                    m.setIcon(getMarker(data.marker_color));
                }
            });
        },

        drawMarker(data, projectData) {
            const Marker = new this.google.maps.Marker({
                ...data,
                map: this.map
            });
            Marker.addListener("click", () =>
                this.markerClicked(data, Marker, projectData)
            );
            this.bounds.extend(data.position);
            return Marker;
        },

        moveTo(position) {
            this.map.panTo(position);
            this.map.panBy(this.mapOffset, 0); // TODO: offset related to zoom (?)
            this.center = position;
        },

        adjustZoom() {
            if (this.markers.length > 0) {
                let minLat, minLng, maxLat, maxLng;

                this.markers.forEach(marker => {
                    const currentLat = marker.position.lat();
                    const currentLng = marker.position.lng();

                    if (!minLat) {
                        minLat = currentLat;
                    }

                    if (!maxLat) {
                        maxLat = currentLat;
                    }

                    if (!minLng) {
                        minLng = currentLng;
                    }
                    if (!maxLng) {
                        maxLng = currentLng;
                    }

                    if (currentLat < minLat) {
                        minLat = currentLat;
                    }

                    if (currentLat > maxLat) {
                        maxLat = currentLat;
                    }

                    if (currentLng < minLng) {
                        minLng = currentLng;
                    }

                    if (currentLng > maxLat) {
                        maxLat = currentLat;
                    }
                });

                const bounds = new this.google.maps.LatLngBounds();

                bounds.extend(new google.maps.LatLng(minLat, minLng));
                bounds.extend(new google.maps.LatLng(maxLat, maxLng));

                this.map.fitBounds(bounds);
            }
        },

        windowResized(e) {
            this.setOffset();
        },

        setOffset() {
            this.checkMobile();
            this.mapOffset = 0;
        },

        scrollToProjectList() {
            if (!this.mobile) {
                return;
            }
            const offset = -200;
            const y =
                this.$refs["project-list"].getBoundingClientRect().top +
                window.pageYOffset +
                offset;

            window.scrollTo({ top: y, behavior: "smooth" });
        },

        checkMobile() {
            this.mobile = window.innerWidth <= 992;
        },

        initMoveEvents() {
            this.map.addListener("dragstart", e => {
                this.isMapDragged = true;
                this.clearPopups();
                this.deactivateMarker();
            });

            this.map.addListener("dragend", e => {
                this.isMapDragged = false;
            });
        },

        setupFilters() {
            const types = [...new Set(this.projects.map(media => media.type))];

            this.filters = types.map(type => {
                const count = this.projects.filter(media => media.type === type)
                    .length;

                return {
                    type,
                    count,
                    active: true
                };
            });
        },

        setupCategories() {
            const categories = [
                ...new Set(this.projects.map(media => media.category))
            ];

            this.categories = categories
                .filter(category => category !== "City transport")
                .map(category => {
                    return {
                        name: category,
                        active: true
                    };
                });
        },

        clearPopups() {
            this.popups.forEach(popup => popup.setMap(null));
            this.popups = [];
            this.deactivateMarker();
        },

        initAutocompleteInput() {
            if (!this.google.maps.places) {
                console.log("[Map] Google Places not found");
                return;
            }

            if (!this.$refs["autocomplete"]) {
                console.log("[Map] Autocomplete element not found");
                return;
            }

            const autocomplete = new this.google.maps.places.Autocomplete(
                this.$refs["autocomplete"]
            );

            autocomplete.addListener("place_changed", () => {
                const place = autocomplete.getPlace();
                // console.log(place);

                if (!place.geometry || !place.geometry.location) {
                    // User entered the name of a Place that was not suggested and
                    // pressed the Enter key, or the Place Details request failed.
                    console.log(
                        "No details available for input: '" + place.name + "'"
                    );
                    return;
                }

                // If the place has a geometry, then present it on a map.
                if (place.geometry.viewport) {
                    this.map.fitBounds(place.geometry.viewport);
                } else {
                    this.map.setCenter(place.geometry.location);
                    this.map.setZoom(17);
                }

                this.searchLatLng = place.geometry.location;
                this.clearPopups();
                this.redrawMarkers();
            });
        },

        deactivateMarker() {
            if (this.active && this.active.Marker) {
                this.active.Marker.setIcon(
                    getMarker(this.active.data.marker_color)
                );
            }
            this.active = null;
        },

        actionsFromUrl() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());

            if (params.lat && params.lng) {
                const lat = parseFloat(params.lat);
                const lng = parseFloat(params.lng);
                const Marker = this.markers.filter(
                    m =>
                        m.getPosition().lat() === lat &&
                        m.getPosition().lng() === lng
                )[0];
                if (Marker) {
                    this.google.maps.event.trigger(Marker, "click", {});
                }
            }

            if (params.categories) {
                const categories = params.categories.toLowerCase().split(",");
                this.categories.map(category => {
                    category.active = categories.includes(
                        category.name.toLowerCase()
                    );
                });

                this.redrawMarkers();
            }
        },

        redrawPublicTransport() {
            if (!this.TramDataFeatureArray) {
                this.TramDataFeatureArray = this.map.data.addGeoJson(
                    this.geojson
                );
            }
            this.map.data.setStyle({
                visible: this.showPublicTransport,
                strokeColor: "#FDB913",
                strokeWeight: 1
            });

            // this.map.data.addListener('click', (event) => {
            //     // INFO:
            //     // Properties: event.feature.h
            //     // Geometry: event.feature.getGeometry()
            //     // Geometry type: event.feature.getGeometry().getType()
            //     // Property from event.feature.h: event.feature.getProperty("route_id") <-- tram number
            // });
        }
    },
    computed: {
        length() {
            if (this.projects) {
                return this.projects.length;
            }
            return 0;
        },

        translations() {
            return warexpoMediaMap;
        },

        resultText() {
            return this.translations.found_x_projects_near
                ? this.translations.found_x_projects_near.replace(
                      "{{x}}",
                      this.length
                  )
                : `Znaleziono ${this.length} realizacji w pobliżu`;
        }
    },

    watch: {
        mapOffset() {
            if (this.map) {
                this.moveTo(this.center);
            }
        },

        distance: {
            handler() {
                this.clearPopups();
                this.redrawMarkers();
            },
            deep: true
        }
    }
};
</script>

<style lang="scss">
@import "./assets/styles/base/variables";
@import "~vue-select/src/scss/vue-select.scss";

.map-wrapper {
    @media (min-width: map-get($grid-breakpoints, "lg")) {
        margin-top: 102px;
    }
}

.media-map__hero {
    margin-top: 70px;
    padding: 70px 0 63px;
    background: $primary-navy-blue;

    .hero-title {
        color: #ffffff;
        font-size: 50px;
        font-weight: 900;
        letter-spacing: 0;
        text-align: center;
        margin: 0;
        //padding: 0 60px 20px;
    }

    .hero__main {
        &__subtitle {
            opacity: 0.9;
            color: $white;
            font-size: 16px;
            letter-spacing: 0;
            line-height: 1.4;
            text-align: center;
        }
    }

    .hero__container {
    }
}

.map-wrapper {
    position: relative;
    height: auto;
    //max-height: 800px;

    &.active {
        padding-top: 384px;
        max-height: 1185px;

        @media (min-width: map-get($grid-breakpoints, "lg")) {
            padding-top: 0;
        }
    }
}

.map {
    //width: calc(100% + 25vw); // TODO: check
    width: 100%;
    //height: 400px;
    height: 800px;
    order: 2;

    @media (min-width: map-get($grid-breakpoints, "sm")) {
        //height: 800px;
    }
}

.map-projects-overlay {
    order: 1;
    transition: 0.7s opacity;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    background: #fff;

    @media (min-width: map-get($grid-breakpoints, "lg")) {
        width: 500px;
        top: 50px;
        left: 10%;
        bottom: 50px;
        right: auto;
        z-index: 1;
        overflow: hidden;
        border-radius: 8px;
        box-shadow: 0 10px 42px -8px rgba(0, 0, 0, 0.41);
    }
}

.map-projects-top {
    padding: 18px 0 0 27px;
}

.project-list {
    width: 100%;
    overflow-y: scroll;
    height: 300px;
    @media (min-width: map-get($grid-breakpoints, "lg")) {
        height: calc(100% - 70px);
    }
}

.title {
    color: #262b36;
    font-size: 22px;
    font-weight: 600;
    line-height: 30px;
}

.results-text {
    color: #606b86;
    font-size: 14px;
    font-weight: 600;
    line-height: 28px;
}

.map {
    &__controls {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 57px;
        flex-wrap: wrap;
        //padding: 0 5%;
        //flex-wrap: wrap;
        @media (min-width: map-get($grid-breakpoints, "lg")) {
            flex-wrap: nowrap;
        }
    }

    &__filters {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-evenly;
        flex-wrap: wrap;
        margin-top: 30px;
        @media (min-width: map-get($grid-breakpoints, "lg")) {
            margin-top: 0;
            padding-left: 10px;
            justify-content: space-evenly;
            max-width: 644px;
        }
    }

    &__filter {
        margin: 5px 2.5px 0;
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0.32px;
        line-height: 20px;
        cursor: pointer;
        color: #fff;
        @media (min-width: map-get($grid-breakpoints, "lg")) {
            margin: 5px 15px 0;
            font-size: 16px;
        }

        &__dot {
            width: 10px;
            height: 10px;
            margin: 5px;
            border: 2px solid #fff;
            border-radius: 50%;
            box-sizing: content-box;

            &--active {
                background: #fdb913;
            }

            &--inactive {
                background: grey;
            }
        }
    }

    &__selects {
        display: flex;
        //flex-wrap: wrap;
    }

    &__select {
        &--address {
            position: relative;
            background: #fff;
            padding-right: 60px;
            border-radius: 2px;
            @media (min-width: map-get($grid-breakpoints, "lg")) {
                width: 340px;
            }
        }

        &--distance {
            position: relative;
            width: 154px;
            margin-left: 34px;
        }
    }

    &__plus {
        position: absolute;
        left: 0;
        z-index: 1;
        padding: 0 13.5px;
        top: 0;
        bottom: 0;
        margin: auto;
        box-sizing: content-box;
    }

    &__directions-icon {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 17px 0 12px;

        &:before {
            content: "";
            position: absolute;
            width: 1px;
            height: 28px;
            left: 0;
            background: #ddd;
        }
    }

    &__hamburger {
        position: absolute;
        height: 100%;
        left: 19px;
    }
}

.popup-bubble {
    position: absolute;
    top: -8px;
    left: 0;
    transform: translate(-50%, -100%);
    background-color: white;
    font-family: sans-serif;
    //overflow-y: auto;
    //max-height: 360px;
    width: 271px;
    box-shadow: 0 10px 24px 0 rgba(0, 0, 0, 0.1);
}

.popup-bubble-anchor {
    position: absolute;
    width: 100%;
    bottom: 8px;
    left: 0;
}

.popup-bubble-anchor::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translate(-50%, 0);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid white;
}

.popup-container {
    cursor: auto;
    height: 0;
    position: absolute;
    width: 200px;
}
.input--address {
    color: gray(0, 0.66);
    padding: 11px 22px 11px 56px;
    //font-size: 1.71em;
    font-family: inherit;
    background: 0 0;
    border: none;
    //border-bottom: 2px solid #fbba00;
    width: 100%;
    background-image: url("data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg width='18px' height='18px' viewBox='0 0 18 18' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EDEE48380-3922-494C-9046-CC482C7DBDA9%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='design_Mapa_nośników' transform='translate(-551.000000, -308.000000)' fill='%23B2B2B2'%3E%3Cg id='google_maps_search' transform='translate(310.000000, 293.000000)'%3E%3Cg id='ic_search_24px' transform='translate(241.000000, 15.000000)'%3E%3Cpath d='M12.5,11 L11.71,11 L11.43,10.73 C12.41,9.59 13,8.11 13,6.5 C13,2.91 10.09,0 6.5,0 C2.91,0 0,2.91 0,6.5 C0,10.09 2.91,13 6.5,13 C8.11,13 9.59,12.41 10.73,11.43 L11,11.71 L11,12.5 L16,17.49 L17.49,16 L12.5,11 L12.5,11 Z M6.5,11 C4.01,11 2,8.99 2,6.5 C2,4.01 4.01,2 6.5,2 C8.99,2 11,4.01 11,6.5 C11,8.99 8.99,11 6.5,11 L6.5,11 Z' id='Shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-position: center right;
    background-repeat: no-repeat;
    border-radius: 2px;
    height: 50px;

    &:focus {
        border: 0;
        outline: none;
    }
}

.loader-wrapper {
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}
</style>

<style lang="scss">
@import "../warexpo/assets/styles/base/mixins";

.v-select {
    background: #fff;
    height: 100%;
    border-radius: 2px;
}

.v-select {
    padding-left: 29px;
}

.vs__dropdown-toggle {
    height: 100%;
    border: 0;
    border-radius: 2px;
}

.vs--single.vs--open .vs__selected,
.vs--single.vs--loading .vs__selected {
    position: relative;
}

.vs__dropdown-option--highlight {
    background: #fab912;
}

.vs__selected-options input {
    @include placeholder {
        color: #757575;
    }
}
</style>
